<template>
  <div>
    <!-- Trigger Button -->
    <v-btn 
      :disabled="disabled" 
      color="primary" 
      :loading="loading" 
      @click="showDialog=true" 
      text
      class="font-weight-black text-uppercase tracking-widest rounded-lg px-4 transition-fast-in-fast-out h-44"
    >
      <v-icon left size="16">far fa-file-excel</v-icon>
      Exportar Bitacora
    </v-btn>

    <!-- Filter & Download Dialog -->
    <v-dialog v-model="showDialog" max-width="440" transition="scale-transition" persistent>
      <v-card class="modern-card overflow-hidden rounded-xl">
        <!-- Premium Header -->
        <div class="bg-grey-light pa-6 border-bottom">
          <div class="d-flex align-center">
            <v-avatar color="primary" size="40" class="mr-4 shadow-sm border-white-sm">
              <v-icon color="white" small>fas fa-filter</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 font-weight-black primary--text lh-1">Exportar Bitacora</div>
              <div class="caption grey--text font-weight-bold text-uppercase tracking-wider mt-1">Configuración de exportación</div>
            </div>
          </div>
        </div>

        <v-card-text class="pa-8 pb-4">
          <div class="caption primary--text font-weight-black text-uppercase tracking-widest mb-6 d-flex align-center">
            <v-icon x-small color="primary" class="mr-2">fas fa-calendar-alt</v-icon> Rango de Fechas
          </div>

          <v-row dense>
            <v-col cols="12" sm="6">
              <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Desde</div>
              <v-text-field
                v-model="local_filter.date_after"
                type="date"
                outlined
                dense
                hide-details
                class="modern-input-field"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Hasta</div>
              <v-text-field 
                v-model="local_filter.date_before"
                type="date"
                outlined
                dense
                hide-details
                class="modern-input-field"
              />
            </v-col>
          </v-row>

          <v-alert
            outlined
            color="primary"
            class="modern-alert rounded-lg mt-8 pa-3"
            icon="fas fa-info-circle"
          >
            <div class="caption primary--text opacity-80">Se generará un archivo Excel con todos los registros de la bitácora según el rango seleccionado.</div>
          </v-alert>
        </v-card-text>

        <v-divider class="mx-8 opacity-10"></v-divider>
        <div class="pa-6 d-flex justify-end gap-3 actions-bg">
          <v-btn 
            text 
            class="modern-btn grey--text font-weight-bold text-none rounded-lg px-6"
            @click="cancel"
          >
            Cancelar
          </v-btn>
          
          <v-btn 
            @click="getExcel" 
            color="success" 
            elevation="0"
            height="44"
            :loading="loading"
            class="modern-btn white--text font-weight-black text-none rounded-lg px-8 shadow-sm"
          >
            <v-icon left size="16">fas fa-download</v-icon>
            Descargar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import notifications from '@/utils/notifications'
import {excelPrestage} from '@/api/production'
import moment from 'moment'

export default {
  name: "ExportPrestage",
  props: {
    filter: { type: Object, required: true },
    options: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    search: { type: String, default: '' }
  },
  data() {
    return {
      loading: false,
      showDialog: false,
      local_filter: {
        date_after: '',
        date_before: ''
      }
    }
  },
  methods: {
    async getExcel() {
      if (!this.local_filter.date_after || !this.local_filter.date_before) {
        notifications.showError('Error', 'Debe seleccionar un rango de fechas')
        return
      }

      this.loading = true
      const { sortBy, sortDesc } = this.options
      
      var created_before = ''
      var created_after = '' 
      if (this.filter.created_after) created_after = moment(this.filter.created_after).utc().format('yyyy-MM-DD HH:mm')
      if (this.filter.created_before) created_before = moment(this.filter.created_before).utc().add(1439, 'minutes').format('yyyy-MM-DD HH:mm')
      
      var date_after = moment(this.local_filter.date_after).utc().format('yyyy-MM-DD HH:mm')
      var date_before = moment(this.local_filter.date_before).utc().add(1439, 'minutes').format('yyyy-MM-DD HH:mm')
      var stage = this.filter.stage == 0 ? '' : this.filter.stage
      
      const query = `ordering=${sortDesc && sortDesc[0] ? sortBy[0] : '-' + (sortBy ? sortBy[0] : 'id')}&page=1&search=${this.search}&created_after=${created_after}&created_before=${created_before}&date_after=${date_after}&date_before=${date_before}&stage=${stage}`
      
      await excelPrestage(query)
        .then((response) => {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(response);
          link.setAttribute('download', `export_prestage_${moment(new Date().toISOString()).format('DD-MM-yyyy_HH:mm')}.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.cancel()
        })
        .catch((error) => {
          notifications.showError('Error al exportar bitácora')
        })
        .finally(() => {
          this.loading = false
        });
    },
    cancel() {
      this.showDialog = false
      this.local_filter.date_after = ''
      this.local_filter.date_before = ''
    }
  }
}
</script>

<style scoped>
.modern-card { border-radius: 12px !important; font-family: 'Outfit', sans-serif !important; }
.bg-grey-light { background-color: #f8fafc !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.06) !important; }
.border-white-sm { border: 2px solid white !important; }
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.05) !important; }
.h-44 { height: 44px !important; }
.lh-1 { line-height: 1 !important; }
.tracking-widest { letter-spacing: 1.5px; }
.tracking-wider { letter-spacing: 0.8px; }
.gap-3 { gap: 12px; }

.modern-input-field >>> .v-input__slot {
  background-color: #f8fafc !important;
  border-radius: 8px !important;
}

.modern-alert {
  background-color: #f1f5f9 !important;
  border: 1px solid #e2e8f0 !important;
}

.modern-btn {
  font-size: 0.9rem !important;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
}
</style>